import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { NzNotificationService } from 'ng-zorro-antd';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { User } from '../Models/Commonmodule/user';
import { Role } from '../Models/Commonmodule/role';
import { Form } from '../Models/Commonmodule/form';
import { Roledetails } from '../Models/Commonmodule/roledetails';
import { Branches } from '../Models/branch';
import { Office } from '../Models/office';
import { Director } from '../Models/director';
import { Officer } from '../Models/officer';
import { Homepage } from '../Models/homepage';
import { MasterDetails } from '../Models/masterdetail';
import { Achivement } from '../Models/archivementmaster';
import { OrgInfo } from '../Models/orginfo';
import { FinancialYearData } from '../Models/financialyeardata';
import { FinancialStatusYears } from '../Models/financialstatusyear';
import { DepositeInterestRates } from '../Models/depositeintrestrate';
import { Loans } from '../Models/loan';
import { LoanInterestRates } from '../Models/loanintrestrate';
import { Deposites } from '../Models/deposite';
import { GalleryGroup } from '../Models/gallarygroupmaster';
import { Gallery } from '../Models/gallerymaster';
import { Investments } from '../Models/investments';
import { Services } from '../Models/servicemaster';
import { DepositeSchemes } from '../Models/depositescheme';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  currentMessage = new BehaviorSubject(null);
  cloudID
  clientId = 1

  // headers for forms all
  httpHeaders = new HttpHeaders();
  options = {
    headers: this.httpHeaders
  };

  // headers for forms file upload call
  httpHeaders1 = new HttpHeaders();
  options1 = {
    headers: this.httpHeaders1
  };

  httpHeaders123 = new HttpHeaders();
  options123 = {
    headers: this.httpHeaders123
  };

  
  baseUrl = "http://admin.krishnakoyanapatsanstha.com:9876/"
 // baseUrl = "http://7c8c-45-249-252-130.ngrok.io/"
  
  gmUrl="http://gm.tecpool.in:8079/"
 // baseUrl = "http://localhost:5055/"
 // baseUrl = "http://103.225.174.99:5055/"
 // gmUrl="http://gm.tecpool.in:8079/"
 
 imgUrl=this.baseUrl +"api/upload/"
 retriveimgUrl=this.baseUrl + "static/";
  url = this.baseUrl + "api/"
  dateforlog=new Date().toLocaleDateString() +" "+ new Date().toLocaleTimeString()
  emailId = sessionStorage.getItem('emailId')
  userId = Number(sessionStorage.getItem('userId'))
  userName = sessionStorage.getItem("userName")
  roleId = sessionStorage.getItem("roleId")
  constructor(private cookie: CookieService, private message: NzNotificationService, private httpClient: HttpClient, private angularFireMessaging: AngularFireMessaging) {
    if (this.cookie.get('deviceId') === '' || this.cookie.get('deviceId') === null) {
      var deviceId = this.randomstring(16)
      this.cookie.set('deviceId',deviceId.toString(),365,"","",false,"Strict");
    }
    // else if(this.userId == null || this.userName == null || this.roleId == null)
    // {
    //   this.logoutForSessionValues()
    // }

    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'apikey': '5a7uxW1Jj5XmWX7c12JE2ueZPmwqVtAj',
      'applicationkey': 'xAw3zZcq0aphqZGJ',
      'deviceid': this.cookie.get('deviceId'),
      'supportkey': this.cookie.get('supportKey'),
      'Token': this.cookie.get('token'),
    });
    this.options = {
      headers: this.httpHeaders
    };

    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }

  getSecondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    if(h==0)
    return m + " m " + s + " s "
    else
    return h + " h " + m +" m "; 
}
  

  //generate string as we pass length - LOGIN_FROMS
  randomstring(L) {
    var s = '';
    var randomchar = function () {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; //1-10
      if (n < 36) return String.fromCharCode(n + 55); //A-Z
      return String.fromCharCode(n + 61); //a-z
    }
    while (s.length < L) s += randomchar();
    return s;
  }

  generateRandomNumber(n) {
    return Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) + Math.pow(10, n - 1);
  }

  logoutForSessionValues()
  {
    this.cookie.delete("supportKey")
    this.cookie.delete("token")
    sessionStorage.clear();
    window.location.reload()
  }

  //firebase methods - FIREBASE
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log("new message received. ", payload);
        this.message.info(payload['data']['title'], payload['data']['body'])
        this.currentMessage.next(payload);
      })
  }

  requestPermission(userId) {
    // this.angularFireMessaging.requestToken.subscribe(
    //   (token) => {
    //     this.cloudID = token
    //     //this.updateToken(userId, token);
    //   },
    //   (err) => {
    //     console.error('Unable to get permission to notify.', err);
    //   }
    // );
  }


  

  // implement logger - LOGGER
  loggerInit() {
    this.httpHeaders1 = new HttpHeaders({
      'Content-Type': 'application/json',
      'apikey': 'SLQphsR7FlH8K3jRFnv23Mayp8jlnp9R',
      'applicationkey': 'pd1zAtB3Bg9pRJp6',
      'deviceid': this.cookie.get('deviceId'),
    });
    this.options1 = {
      headers: this.httpHeaders1
    };
    
    var data = {
      CLIENT_ID: this.clientId
    };
    return this.httpClient.post(this.gmUrl + "device/init", JSON.stringify(data), this.options1);
  }

  addLog(type, text, userId): Observable<number> {
    this.httpHeaders1 = new HttpHeaders({
      'Content-Type': 'application/json',
      'apikey': 'SLQphsR7FlH8K3jRFnv23Mayp8jlnp9R',
      'applicationkey': 'pd1zAtB3Bg9pRJp6',
      'deviceid': this.cookie.get('deviceId'),
      'supportkey': this.cookie.get('supportKey'),
      'Token': this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1
    };
    var data = {
      LOG_TYPE: type,
      LOG_TEXT: this.dateforlog + " "+  text,
      USER_ID: userId,
      CLIENT_ID: this.clientId
    };
    return this.httpClient.post<number>(this.gmUrl + "device/addLog", JSON.stringify(data), this.options1);
  }

  // login method - LOGIN
  login(email: string, password: string) {
    this.httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'apikey': '5a7uxW1Jj5XmWX7c12JE2ueZPmwqVtAj',
      'applicationkey': 'xAw3zZcq0aphqZGJ',
      'deviceid': this.cookie.get('deviceId'),
      'supportkey': this.cookie.get('supportKey'),
      'Token': this.cookie.get('token'),
    });
    this.options = {
      headers: this.httpHeaders
    };
    var data = {
      username: email,
      password: password,
    };
    return this.httpClient.post(this.baseUrl + "user/login", JSON.stringify(data), this.options);
  }


  onUpload(folderName,selectedFile,filename){
    this.httpHeaders1 = new HttpHeaders({
      'Accept': 'application/json',
      'apikey': '5a7uxW1Jj5XmWX7c12JE2ueZPmwqVtAj',
      'Token': this.cookie.get('token'),
      'supportkey': this.cookie.get('supportKey'),
        });
        this.options1 = {
      headers: this.httpHeaders1
    };
   
    const fd=new FormData()
    fd.append("Image",selectedFile,filename)
    this.httpClient.post(this.imgUrl+folderName,fd ,this.options1)
      .subscribe(res => {
        console.log(res);
      });
  }

  // upload image with key - UPLOAD_IMAGE
  onUploadNewMethod(selectedFile, ext, fKey) {
    this.httpHeaders1 = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      'Accept': 'application/json',
      'f_key': fKey,
      'f_ext': ext,
      'supportkey': this.cookie.get('supportKey'),
      'apikey': 'SLQphsR7FlH8K3jRFnv23Mayp8jlnp9R',
      'applicationkey': 'pd1zAtB3Bg9pRJp6',
      'Token': this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1
    };
    const fd = new FormData()
    fd.append("F_DATA", selectedFile)
    fd.append("F_EXT", ext)
    fd.append("F_KEY", fKey)
    return this.httpClient.post(this.gmUrl + 'file/upload', fd, this.options1)
  }


  onUploadNewMethodBulk(selectedFile) {
  //  console.log(selectedFile[0],selectedFile[0].name.split('.').pop(),selectedFile[0].f_key)
    this.httpHeaders1 = new HttpHeaders({
      //'Content-Type': 'multipart/form-data',
      'Accept': 'application/json',
      'f_key': selectedFile[0].f_key,
      'f_ext': selectedFile[0].name.split('.').pop(),
      'supportkey': this.cookie.get('supportKey'),
      'apikey': 'SLQphsR7FlH8K3jRFnv23Mayp8jlnp9R',
      'applicationkey': 'pd1zAtB3Bg9pRJp6',
      'Token': this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1
    };
  
    const fd = new FormData()
    console.log(selectedFile)
    if(selectedFile.length>1)
    {
      for (let file of selectedFile) {
        let name=file.f_key+"_"+file.url_key+"."+file.name.split('.').pop();
        fd.append("F_DATA", file , name)
    }
    return this.httpClient.post(this.gmUrl + 'File/uploadBulk', fd, this.options1)
    }
    else
    {
      var list
    //  let name=selectedFile[0].f_key+"_"+selectedFile[0].url_key+"."+selectedFile[0].name.split('.').pop();

    fd.append("F_DATA", selectedFile[0])
      fd.append("F_EXT", selectedFile[0].name.split('.').pop())
      fd.append("F_KEY", selectedFile[0].f_key)
      let url_key=selectedFile[0].url_key
      console.log("URL_KEY "+url_key)
      var singleData= this.httpClient.post(this.gmUrl + 'file/upload', fd, this.options1)
      return singleData
    }
   
   
  }


  //retrive file - GETTING_FILE
  getFile(lkey) {
    this.httpHeaders1 = new HttpHeaders({
      'Accept': 'application/pdf',
      'supportkey': this.cookie.get('supportKey'),
      'apikey': 'SLQphsR7FlH8K3jRFnv23Mayp8jlnp9R',
      'applicationkey': 'pd1zAtB3Bg9pRJp6',
      'Token': this.cookie.get('token'),
    });
    this.options1 = {
      headers: this.httpHeaders1
    };
 
    var data = {
      L_KEY: lkey
    };
    return this.httpClient.post<any>(this.gmUrl + 'file/getFile', data, this.options1)
  }

  // onUpload(folderName,selectedFile,filename){
  //   console.log(this.httpHeaders1)
  //   const fd=new FormData()
  //   fd.append("Image",selectedFile,filename)
  //   console.log("selected file"+JSON.stringify(selectedFile))
  //   console.log("form data: "+fd)
  //   this.httpClient.post(this.imgUrl+folderName,fd ,this.options1)
  //     .subscribe(res => {
  //       console.log(res);
  //     });
  // }



  //get all Form For login menu
  getForms(roleId: number) {
    var data = {
      ROLE_ID: roleId,
    };
    return this.httpClient.post<Roledetails>(this.url + "user/getForms", JSON.stringify(data), this.options);
  }

  getCheckAccessOfForm(roleId: number,link:string) {
    var data = {
      ROLE_ID: roleId,
      LINK:link
    };
    return this.httpClient.post<Roledetails>(this.url + "roleDetails/checkAccess", JSON.stringify(data), this.options);
  }

  //methods for form related opearation  - FORM
  getAllForms(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<Form[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<Form[]>(this.url + "form/get", JSON.stringify(data), this.options);
  }

  createForm(form: Form): Observable<number> {
  form.CLIENT_ID=this.clientId
  return this.httpClient.post<number>(this.url + "form/create/", JSON.stringify(form), this.options);
  }

  updateForm(form: Form): Observable<number> {
    form.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(this.url + "form/update/", JSON.stringify(form), this.options);
  }

  //methods for role related opearation  - ROLE
  getAllRoles(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<Role[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<Role[]>(this.url + "role/get", JSON.stringify(data), this.options);
  }

  createRole(application: Role): Observable<number> {
    application.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(this.url + "role/create/", JSON.stringify(application), this.options);
  }

  updateRole(application: Role): Observable<number> {
    application.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(this.url + "role/update/", JSON.stringify(application), this.options);
  }

  //get all form assigned - ROLE_DETAILS
  getRoleDetails(roleId: number) {
    var data = {
      ROLE_ID: roleId
    };
    console.log(roleId)
    return this.httpClient.post<Roledetails[]>(this.url + "roleDetails/getData", JSON.stringify(data), this.options);
  }

  //assign all method forms - ROLE_DETAILS
  addRoleDetails(roleId: number, data1: string[]): Observable<number> {
    console.log(roleId)
    var data = {
      ROLE_ID: roleId,
      data: data1,
    };
    return this.httpClient.post<number>(this.url + "roleDetails/addBulk", data, this.options);
  }

  //method for user replated opearation - USER
  getAllUsers(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<User[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<User[]>(this.url + "user/get", JSON.stringify(data), this.options);
  }

  createUser(user: User): Observable<number> {
    user.CLIENT_ID = this.clientId;
    return this.httpClient.post<number>(this.url + "user/create/", JSON.stringify(user), this.options);
  }

  updateUser(user: User): Observable<number> {
    user.CLIENT_ID = this.clientId;
    return this.httpClient.put<number>(this.url + "user/update/", JSON.stringify(user), this.options);
  }
  getAllBranches(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    
    return this.httpClient.post<Branches[]>(this.baseUrl + "api/branches/get", JSON.stringify(data), this.options);
  }
  
  createBranches(branches: Branches) {
  
    branches.CLIENT_ID=this.clientId;
    return this.httpClient.post<number>(this.baseUrl + "api/branches/create", JSON.stringify(branches), this.options);
  }
  
  updateBranches(branches: Branches) {
    
    branches.CLIENT_ID=this.clientId;
    return this.httpClient.put<number>(this.baseUrl + "api/branches/update", JSON.stringify(branches), this.options);
  }

  getAllOffice(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<Office[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<Office[]>(this.url + "office/get", JSON.stringify(data), this.options);
  }

  createOffice(office: Office): Observable<number> {
 
    office.CLIENT_ID=this.clientId;
    return this.httpClient.post<number>(this.url + "office/create/", JSON.stringify(office), this.options);
  }

  updateOffice(office: Office): Observable<number> {
    
    office.CLIENT_ID=this.clientId;
    return this.httpClient.put<number>(this.url + "office/update/", JSON.stringify(office), this.options);
  }
  getAllDirectors(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<Director[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<Director[]>(this.baseUrl + "api/directors/get", JSON.stringify(data), this.options);
  }

  createDirectors(directors: Director): Observable<number> {
 
    directors.CLIENT_ID=this.clientId;
    return this.httpClient.post<number>(this.baseUrl + "api/directors/create/", JSON.stringify(directors), this.options);
  }

  updateDirectors(directors: Director): Observable<number> {
    
    directors.CLIENT_ID=this.clientId;
    return this.httpClient.put<number>(this.baseUrl + "api/directors/update/", JSON.stringify(directors), this.options);
  }



  getAllOfficers(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string): Observable<Officer[]> {
    var data = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortKey: sortKey,
      sortValue: sortValue,
      filter: filter
    };
    return this.httpClient.post<Officer[]>(this.baseUrl + "api/officers/get", JSON.stringify(data), this.options);
  }

  createOfficer(officer: Officer): Observable<number> {
 
    officer.CLIENT_ID=this.clientId;
    return this.httpClient.post<number>(this.baseUrl + "api/officers/create/", JSON.stringify(officer), this.options);
  }

  updateOfficer(officer: Officer): Observable<number> {
    
    officer.CLIENT_ID=this.clientId;
    return this.httpClient.put<number>(this.baseUrl + "api/officers/update/", JSON.stringify(officer), this.options);
  }




getAllHomepages(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };

  return this.httpClient.post<Homepage[]>(this.baseUrl + "api/homepage/get", JSON.stringify(data), this.options);
}

createHomepage(homepage: Homepage) {

  homepage.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/homepage/create", JSON.stringify(homepage), this.options);
}

updateHomepage(homepage: Homepage) {
  
  homepage.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/homepage/update", JSON.stringify(homepage), this.options);
}



getAllMasterDetails(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<MasterDetails[]>(this.baseUrl + "api/masterDetails/get", JSON.stringify(data), this.options);
}

createMasterDetails(masterDetails: MasterDetails) {

  masterDetails.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/masterDetails/create/", JSON.stringify(masterDetails), this.options);
}

updateMasterDetails(masterDetails: MasterDetails) {
  
  masterDetails.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/masterDetails/update/", JSON.stringify(masterDetails), this.options);
}


getAllAchivement(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Achivement[]>(this.baseUrl + "api/achivement/get", JSON.stringify(data), this.options);
}

createAchivement(achivement: Achivement){

  achivement.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/achivement/create/", JSON.stringify(achivement), this.options);
}

updateAchivement(achivement: Achivement) {
  
  achivement.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/achivement/update/", JSON.stringify(achivement), this.options);
}

getAllOrgInfo(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<OrgInfo[]>(this.baseUrl + "api/orgInfo/get", JSON.stringify(data), this.options);
}

createOrgInfo(orgInfo: OrgInfo) {

  orgInfo.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/orgInfo/create/", JSON.stringify(orgInfo), this.options);
}

updateOrgInfo(orgInfo: OrgInfo) {
  
  orgInfo.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/orgInfo/update/", JSON.stringify(orgInfo), this.options);
}

getAllFinancialYearData(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<FinancialYearData[]>(this.baseUrl + "api/financialYearData/get", JSON.stringify(data), this.options);
}

createFinancialYearData(financialYearData: FinancialYearData) {

  financialYearData.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/financialYearData/create", JSON.stringify(financialYearData), this.options);
}

updateFinancialYearData(financialYearData: FinancialYearData){
  
  financialYearData.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/financialYearData/update", JSON.stringify(financialYearData), this.options);
}


getAllFinancialStatusYears(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
    return this.httpClient.post<FinancialStatusYears[]>(this.baseUrl + "api/financialStatusYears/get", JSON.stringify(data), this.options);
}

createFinancialStatusYears(financialStatusYears: FinancialStatusYears) {

  financialStatusYears.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/financialStatusYears/create", JSON.stringify(financialStatusYears), this.options);
}

updateFinancialStatusYears(financialStatusYears: FinancialStatusYears){
  
  financialStatusYears.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/financialStatusYears/update", JSON.stringify(financialStatusYears), this.options);
}




getAllDepositeInterestRates(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string){
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
 
  return this.httpClient.post<DepositeInterestRates[]>(this.baseUrl + "api/depositeInterestRates/get", JSON.stringify(data), this.options);
}

createDepositeInterestRates(depositeInterestRates: DepositeInterestRates){

  depositeInterestRates.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/depositeInterestRates/create/", JSON.stringify(depositeInterestRates), this.options);
}

updateDepositeInterestRates(depositeInterestRates: DepositeInterestRates) {
  
  depositeInterestRates.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/depositeInterestRates/update/", JSON.stringify(depositeInterestRates), this.options);
}



getAllLoans(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Loans[]>(this.baseUrl + "api/loans/get", JSON.stringify(data), this.options);
}

createLoans(loans: Loans) {

  loans.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/loans/create/", JSON.stringify(loans), this.options);
}

updateLoans(loans: Loans) {
  
  loans.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/loans/update/", JSON.stringify(loans), this.options);
}


getAllLoanInterestRates(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
 
  return this.httpClient.post<LoanInterestRates[]>(this.baseUrl + "api/loanInterestRates/get", JSON.stringify(data), this.options);
}

createLoanInterestRates(loanInterestRates: LoanInterestRates) {

  loanInterestRates.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/loanInterestRates/create/", JSON.stringify(loanInterestRates), this.options);
}

updateLoanInterestRates(loanInterestRates: LoanInterestRates) {
  
  loanInterestRates.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/loanInterestRates/update/", JSON.stringify(loanInterestRates), this.options);
}


getAllDeposites(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Deposites[]>(this.baseUrl + "api/deposites/get", JSON.stringify(data), this.options);
}

createDeposites(deposites: Deposites) {

  deposites.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/deposites/create/", JSON.stringify(deposites), this.options);
}

updateDeposites(deposites: Deposites) {
  
  deposites.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/deposites/update/", JSON.stringify(deposites), this.options);
}


getAllGalleryGroup(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string){
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<GalleryGroup[]>(this.baseUrl + "api/galleryGroup/get", JSON.stringify(data), this.options);
}

createGalleryGroup(galleryGroup: GalleryGroup) {

  galleryGroup.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/galleryGroup/create/", JSON.stringify(galleryGroup), this.options);
}

updateGalleryGroup(galleryGroup: GalleryGroup){
  
  galleryGroup.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/galleryGroup/update/", JSON.stringify(galleryGroup), this.options);
}



getAllGallery(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Gallery[]>(this.baseUrl + "api/gallery/get", JSON.stringify(data), this.options);
}

createGallery(gallery: Gallery){

  gallery.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/gallery/create/", JSON.stringify(gallery), this.options);
}

updateGallery(gallery: Gallery) {
  
  gallery.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/gallery/update/", JSON.stringify(gallery), this.options);
}



getAllInvestments(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Investments[]>(this.baseUrl + "api/investments/get", JSON.stringify(data), this.options);
}

createInvestments(investments: Investments) {

  investments.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/investments/create/", JSON.stringify(investments), this.options);
}

updateInvestments(investments: Investments) {
  
  investments.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/investments/update/", JSON.stringify(investments), this.options);
}


getAllDepositeSchemes(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };

  return this.httpClient.post<DepositeSchemes[]>(this.baseUrl + "api/depositeSchemes/get", JSON.stringify(data), this.options);
}

createDepositeSchemes(depositeSchemes: DepositeSchemes) {

  depositeSchemes.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/depositeSchemes/create/", JSON.stringify(depositeSchemes), this.options);
}

updateDepositeSchemes(depositeSchemes: DepositeSchemes) {
  
  depositeSchemes.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/depositeSchemes/update/", JSON.stringify(depositeSchemes), this.options);
}



getAllServices(pageIndex: number, pageSize: number, sortKey: string, sortValue: string, filter: string) {
  var data = {
    pageIndex: pageIndex,
    pageSize: pageSize,
    sortKey: sortKey,
    sortValue: sortValue,
    filter: filter
  };
  
  return this.httpClient.post<Services[]>(this.baseUrl + "api/services/get", JSON.stringify(data), this.options);
}

createServices(services: Services){

  services.CLIENT_ID=this.clientId;
  return this.httpClient.post<number>(this.baseUrl + "api/services/create/", JSON.stringify(services), this.options);
}

updateServices(services: Services) {
  
  services.CLIENT_ID=this.clientId;
  return this.httpClient.put<number>(this.baseUrl + "api/services/update/", JSON.stringify(services), this.options);
}






publish(formName)
{
  return this.httpClient.put<number>(this.baseUrl + "api/" + formName + "/publish", "", this.options);
}


preview(formName)
{
  return this.httpClient.put<number>(this.baseUrl + "api/" + formName + "/preview", "", this.options);
}

}
